"use client";
import { usePathname } from "next/navigation";
import { LegalLinks } from "@/components/corners";
import { SiteNav } from "@/components/site-nav";

// Pages that keep only the top-left mark and the bottom-right copyright.
const BARE = new Set(["/catalog-form"]);

export function PageNav() {
  return BARE.has(usePathname()) ? null : <SiteNav />;
}

export function PageLegal() {
  return BARE.has(usePathname()) ? null : <LegalLinks />;
}
